import { render, staticRenderFns } from "./Appartenenza.vue?vue&type=template&id=4de3257e&"
import script from "./Appartenenza.vue?vue&type=script&lang=ts&"
export * from "./Appartenenza.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports